import { useEffect } from "react";
/**
 * listen to the update of the data-personalised attribute, and update the options if the amount changes it.
 * This would be used in:
 * - Selection.js
 * - AmountSelector.js
 *
 * @param {*} selectInputRef ref of the selection button group
 * @param {*} setOptions function to set options for the selection
 * @param {*} options current options value
 */
const useListenDataPersonalise = (selectInputRef, setOptions, options) => {
  useEffect(() => {
    const selectorElement = selectInputRef.current;

    if (!selectorElement) return;

    // Function to execute when mutations are observed
    const handleMutation = (mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "data-personalised") {
          const newPersonalisedData = selectorElement.getAttribute("data-personalised");

          // Update options here if necessary
          // setOptions(...) based on newPersonalisedData
          //check if we need to update the options
          if (newPersonalisedData) {
            const array = JSON.parse(newPersonalisedData);
            if (array !== options && array.length === 3 && typeof array[0] === "string") {
              setOptions(array);
            }
          }
        }
      });
    };

    // Create an observer instance linked to the handleMutation function
    const observer = new MutationObserver(handleMutation);

    // Start observing the target element for configured mutations
    observer.observe(selectorElement, { attributes: true });

    // Clean up the observer on component unmount
    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useListenDataPersonalise;
